export default "__VITE_ASSET__3550b283__"